// language=GraphQL
export const ALL_AVAILABLE_ADDONS_QUERY = `query Query($withIcon: Boolean = false) {
  availableAddons: accommodationAvailableAddons {
    id
    name
    description
    icon @include(if: $withIcon) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_AVAILABLE_ADDON_QUERY = `query Query($id: ID!, $withIcon: Boolean = false) {
  availableAddon: accommodationAvailableAddon(id: $id) {
    id
    name
    description
    icon @include(if: $withIcon) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_AVAILABLE_ADDON_MUTATION = `
  mutation Mutation($input: CreateAccommodationAvailableAddonInput, $withIcon: Boolean = false) {
    availableAddon: createAccommodationAvailableAddon(input: $input) {
      id
      name
      description
      icon @include(if: $withIcon) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_AVAILABLE_ADDON_MUTATION = `
  mutation Mutation($input: UpdateAccommodationAvailableAddonInput, $withIcon: Boolean = false) {
    availableAddon: updateAccommodationAvailableAddon(input: $input) {
      id
      name
      description
      icon @include(if: $withIcon) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_AVAILABLE_ADDON_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAvailableAddonInput) {
    deleteAccommodationAvailableAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AVAILABLE_ADDON_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAvailableAddonInput) {
    forceDeleteAccommodationAvailableAddon(input: $input) {
      success
    }
  }`
// language=GraphQL
export const AVAILABLE_ADDONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withAccommodations: Boolean = false) {
  groupedDependents: accommodationAvailableAddonDependents(id: $id) {
    accommodations @include(if: $withAccommodations) {
      id
      label
      name
      stars
      description
    }
  }
}`
